/* eslint-disable react/prop-types */
import React from "react";
import { Card, CardContainer } from "../../../components/Card";
import { Typography, useTheme } from "@mui/material";

const formatRevenue = (revenue) => {
    if (revenue >= 10000000) {
        return `${(revenue / 10000000).toFixed(1)}cr`;
    } else if (revenue >= 100000) {
        return `${(revenue / 100000).toFixed(1)}L`;
    } else if (revenue >= 1000) {
        return `${(revenue / 1000).toFixed(1)}k`;
    } else {
        return `${revenue.toLocaleString()}`;
    }
};

function TopCards({ data }) {
    const theme = useTheme();

    const calculateTotal = (key) => {
        return data?.reduce((sum, item) => sum + (item[key] || 0), 0);
    };

    const cardStyle = {
        flex: 1,
        backgroundColor: "#ffffff",

        borderRadius: "12px",
        // boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",

        width: "100%",
        marginTop: "10px",
        height: "33vh",
    };

    return (
        <div style={cardStyle}>
            <CardContainer>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.cyan,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("student_attendees"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Student Attendees
                    </Typography>
                </Card>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.yellow,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("events"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Total Events
                    </Typography>
                </Card>
            </CardContainer>
            <br />
            <CardContainer>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.magenta,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("ticketed"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Ticketed
                    </Typography>
                </Card>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.purple,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("non_ticketed"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Non Ticketed
                    </Typography>
                </Card>
            </CardContainer>
            <br />

            <CardContainer>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.pink,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("unique_earners"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Number of Kids Paid
                    </Typography>
                </Card>
                <Card>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.graph.orange,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {formatRevenue(calculateTotal("student_wallet"))}
                    </Typography>
                    <Typography
                        variant="captionRegular"
                        sx={{
                            color: theme.palette.neutral[500],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Amount Paid
                    </Typography>
                </Card>
            </CardContainer>
        </div>
    );
}

export default TopCards;
